<template>
  <!-- <b-container> -->
  <b-container>
    <div class="no-merchant" v-if="errorLoading">
      <h2>Merchant Not Found</h2>
    </div>

    <div v-if="!errorLoading">
      <h2>Merchant Information</h2>

      <div v-if="merchantLoading">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>

      <v-card :outlined="true" v-else>
        <v-card-text>
          <div>
            <div class="pv">
              <span class="title">Name:</span
              ><span class="value"> {{ merchant.merchantName }}</span>
            </div>
            <div class="pv">
              <span class="title">Email: </span
              ><span class="value">{{ merchant.contactEmail }}</span>
            </div>
            <div class="pv">
              <span class="title">Signup:</span>
              <span class="value"> {{ merchant.signUpDate }}</span>
            </div>
            <div class="pv">
              <span class="title">Last Payment: </span>
              <span class="value">{{ merchant.lastPaymentDate }}</span>
            </div>

            <div class="pv">
              <span class="title">Next Payment: </span>
              <span class="value">{{ merchant.nextPaymentDate }}</span>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>

    <br />

    <div v-if="!errorLoading">
      <h2>Payment Information</h2>

      <v-data-table
        v-if="!errorLoading"
        :headers="headers"
        :items="payments"
        item-class="table-rows"
        :loading="merchantLoading"
        class="elevation-1 pr-t-class"
        loading-text="Loading... Please wait"
      >
      </v-data-table>
    </div>
  </b-container>
</template>
<script>
import { API, graphqlOperation } from "aws-amplify";
import { getMerchantDetails } from "../../../../graphql/queries";
export default {
  data() {
    return {
      errorLoading: false,
      merchant: {
        merchantName: "",
        contactEmail: "",
        nextPaymentDate: "",
        lastPaymentDate: ""
      },
      payments: [],
      merchantLoading: false,
      headers: [{ text: "Payment Date", value: "paymentDate", align: "center" }]
    };
  },

  methods: {
    async updateMerchant(merchantName) {
      try {
        this.merchantLoading = true;
        const response = await this.getMerchant(merchantName);
        if (!response.success || response.error || !response.data.merchant) {
          this.errorLoading = true;
          throw new Error("Error loading merchant");
        }

        this.merchant = response.data.merchant;
        this.payments = response.data.payments;
        this.merchantLoading = false;
      } catch (error) {
        this.merchantLoading = false;
        this.$logger.error(error);
        this.createToast("danger", error?.message ?? "Something went wrong");
      }
    },

    async getMerchant(merchantName) {
      const { data } = await API.graphql(
        graphqlOperation(getMerchantDetails, { merchantName: merchantName })
      );
      const response = data.getMerchantDetails;

      return response;
    },
    createToast(variant, message) {
      this.$bvToast.toast(message, {
        title: "Merchant Details Settings",
        autoHideDelay: 5000,
        variant,
        append: true
      });
    }
  },

  async mounted() {
    const merchantName = this.$route.params.merchantName;
    await this.updateMerchant(merchantName);
  }
};
</script>
<style scoped>
.no-merchant {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 65px;
}
.pv {
  margin-bottom: 10px;
}

.title {
  font-weight: bold;
  margin-right: 10px;
}
.value {
  font-size: larger;
}
</style>
